// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export const KEY_SHORT_COMMISSION_INFO = 'InstrumentDetailsPanel.ShortCommissionInfo';
export const KEY_OPTION_EXERCISE = 'InstrumentDetailsPanel.OptionExercise';
export const KEY_CUSTODIAL_FEE = 'InstrumentDetailsPanel.CustodialFee';
export const KEY_SHORT_POSITION_INTEREST = 'InstrumentDetailsPanel.ShortPostionInterest';
export const KEY_FILLPERLOT = 'InstrumentDetailsPanel.PerLot';
export const KEY_ORDERPERLOT = 'InstrumentDetailsPanel.OrderPerLot';
export const KEY_PERFILL = 'InstrumentDetailsPanel.PerFill';
export const KEY_PERTRANSACTION = 'InstrumentDetailsPanel.PerTransaction';
export const KEY_PERPHONETRANSACTION = 'InstrumentDetailsPanel.PerPhoneTransaction';
export const KEY_PERVOLUME = 'InstrumentDetailsPanel.PerVolume';
export const KEY_PERORDERVOLUME = 'InstrumentDetailsPanel.PerOrderVolume';
export const KEY_VAT = 'InstrumentDetailsPanel.VAT';
export const KEY_VOLUME_WITH_MIN_PD = 'InstrumentDetailsPanel.VolumeWithMinPD';
export const KEY_VOLUME = 'InstrumentDetailsPanel.Volume';
export const KEY_ORDER_VOLUME = 'InstrumentDetailsPanel.OrderVolume';
export const KEY_CARE_ORDER = 'InstrumentDetailsPanel.CareOrder';
export const KEY_ORDER_PER_LOT_WITH_FIXED_PART = 'InstrumentDetailsPanel.OrderPerLotWithFixedPart';
export const KEY_TOTAL_FEE = 'InstrumentDetailsPanel.TotalFee';
export const KEY_SWAP_BUY = 'InstrumentDetailsPanel.SwapBuy';
export const KEY_SWAP_SELL = 'InstrumentDetailsPanel.SwapSell';
export const KEY_FILL_FACE_VALUE = 'InstrumentDetailsPanel.FillFaceValue';
